import ThreeByOneWidgetGrid, {
  ThreeByOneWidgetGridProps,
} from './ThreeByOneWidgetGrid';

export default ThreeByOneWidgetGrid;
export type { ThreeByOneWidgetGridProps };
